module.exports = __webpack_public_path__ + "static/img/new-master-platform@t.acabc44.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos/new-master-platform@t.jpg
// module id = hOqg
// module chunks = 0